import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { routes } from '../constants';
import { selectUser } from '../reducers/user.selectors';
import useRouter from './useRouter';

/**
 * Returns a `navigateHome` callback that routes the user to their home page.
 * AI-only users land on the AI tools page; everyone else on the dashboard.
 * Shared by the side nav and top bar logos so both stay in sync.
 */
const useHomeNavigation = (): (() => void) => {
  const { router } = useRouter();
  const user = useSelector(selectUser);

  return useCallback(() => {
    const homeRoute = user?.isAiOnlyUser
      ? `/${routes.aiTools.root}`
      : `/${routes.dashboard.root}`;
    router.push(homeRoute);
  }, [router, user?.isAiOnlyUser]);
};

export default useHomeNavigation;
